import PersonalDataEdit from "./PersonalDataEdit";

export default PersonalDataEdit;
